// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-6140b688!./~/sass-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Gallery/GalleryFull.vue
// module id = 286
// module chunks = 2